module.exports = __webpack_public_path__ + "static/media/dermaidLogo.4edf158f.webp";